var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.recoverySale.ID > 0
    ? _c(
        "w-row",
        [
          _c("w-col", { attrs: { sm: "12" } }, [
            _c(
              "div",
              { staticClass: "recovery-info" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$ct(_vm.lastSavedText)) +
                    " " +
                    _vm._s(_vm.lastSaved) +
                    " | "
                ),
                _vm.differenceInSale
                  ? _c(
                      "w-link",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.recover()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$ct("restore")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }